<script setup>
import apiDriveListe from "@/services/http/api-drive/client/listeDeCourse";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useContextStore } from "@/store/context";
import { useMagasinStore } from "@/store/magasin";

const app = useNuxtApp();
const { params } = useRoute();
const { trackPage } = useTrackingPage();

definePageMeta({
  middleware: "authenticated"
});

const { id: magasinId } = storeToRefs(useMagasinStore());

const { layout } = storeToRefs(useContextStore());

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/mon-compte/mes-listes-de-courses/details/${layout.value}.vue`
    ]
  );
});

const id = ref(params.id);

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.monCompte);
});

const { data, pending, refresh } = await useAsyncData((app) =>
  app.$apiDrive.use(apiDriveListe).listeDeCourse(magasinId.value, id.value)
);

const liste = computed(() => {
  return data.value ? data.value.data : null;
});

const meta = computed(() => {
  return data.value ? data.value.meta : null;
});
</script>

<template>
  <div>
    <component
      :is="component"
      :id="id"
      :liste="liste"
      :meta="meta"
      :page-is-loading="pending"
      @reload="refresh()"
    />
  </div>
</template>
